import React from "react";
import { BASE_URL } from '../../constants';
import { Link } from "react-router-dom";
import { getSiteId } from "../../Utils/helper";
const SupportPopup = ({closePopup}) => {
  return (
    <div>
      <div className="success-popup-upper">
        <div className="success-popup">
          <img src={`${BASE_URL}/assets/images/support.png`} />
          <h5>¿Necesitas Ayuda?</h5>
          <p>Enseguida vendrá alguien a auxiliarte.</p>
          <div className="popup-button">
            <button onClick={closePopup} className="btn btn-cancel">Cancelar</button>
              <Link to={`/${getSiteId()}/help`} className="btn btn-success">
              Confirmar
              </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPopup;
